import { useMutation } from '@tanstack/react-query';

import { trackingV4VerifyAndGetTracking } from '@/api/generated';

type VerifyTrackingParams = {
  publicId: string;
  last_name: string;
  date_of_birth: string;
};

export function useVerifyTracking() {
  return useMutation({
    mutationFn: async ({ publicId, last_name, date_of_birth }: VerifyTrackingParams) => {
      const { data } = await trackingV4VerifyAndGetTracking({
        body: { last_name, date_of_birth },
        path: { public_id: publicId },
      });
      return data.payload;
    },
  });
}
